import { useCan } from "@app/hooks/use-can";
import { usePermissions } from "@app/hooks/use-permissions";
import { ACTIONS } from "@app/auth/permission-actions";
import { LoadingCard } from "@app/components/base/loading-state/loading-card";
import { ModuleAccessMatrix } from "./module-access-matrix";
import { UserAssignmentsSection } from "./user-assignments-section";

export function PermissionsPage() {
    const {
        roles,
        modules,
        users,
        roleAssignments,
        rolePreviewUsersByRoleId,
        getPermission,
        updatePermission,
        assignUser,
        unassignUser,
        isLoading,
        loadingRoleIds,
        pendingCells,
        pendingUserIds,
        isLoadingUsers,
        hasNextUsersPage,
        fetchNextUsersPage,
        fetchUsersByName,
        error,
    } = usePermissions();

    const canEdit = useCan(ACTIONS.permissions.write);

    return (
        <div className="flex flex-col gap-8">
            <div>
                <h1 className="text-2xl font-semibold text-gray-900">Permissions</h1>
                <p className="mt-2 max-w-3xl text-sm leading-relaxed text-gray-600">
                    Users can hold multiple roles. The Submitter role is automatically assigned and is not managed here. Click a blue permission to adjust its
                    access level.
                </p>
            </div>

            {error && (
                <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" role="alert">
                    {error}
                </div>
            )}

            {isLoading ? (
                <LoadingCard label="Loading permissions…" description="Please wait while roles and modules load." className="min-h-[200px]" />
            ) : (
                <>
                    <ModuleAccessMatrix
                        roles={roles}
                        modules={modules}
                        pendingCells={pendingCells}
                        getPermission={getPermission}
                        onPermissionChange={updatePermission}
                        canEdit={canEdit}
                    />

                    <UserAssignmentsSection
                        roles={roles}
                        roleAssignments={roleAssignments}
                        rolePreviewUsersByRoleId={rolePreviewUsersByRoleId}
                        users={users}
                        loadingRoleIds={loadingRoleIds}
                        pendingUserIds={pendingUserIds}
                        isLoadingUsers={isLoadingUsers}
                        hasNextUsersPage={hasNextUsersPage}
                        onLoadMoreUsers={fetchNextUsersPage}
                        fetchUsersByName={fetchUsersByName}
                        onAssign={assignUser}
                        onUnassign={unassignUser}
                        canEdit={canEdit}
                    />
                </>
            )}
        </div>
    );
}
